export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = (password) => {
  if (!password) return 'Password is required';
  if (password.length < 6) return 'Password must be at least 6 characters long';
  return true;
};

export const validateResetPassword = (password) => {
  if (!password) {
    return 'Password is required.';
  }

  const pattern = /^(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{6,}$/;

  if (!pattern.test(password)) {
    return 'Password must be at least 6 characters (e.g. Pass1@)';
  }

  return true;
};

export const getAllowedFileExtensions = (selectedFileType) => {
  if (!selectedFileType) {
    return '';
  }
  return selectedFileType
    .split(',')
    .map((type) => {
      const parts = type.trim().split('/');
      return parts.length === 2 ? `.${parts[1]}` : '';
    })
    .filter((ext) => ext)
    .join(', ');
};
